<script setup lang="ts">
import { useBlogCategory, useBlogCategoryFallback } from '../../services/blog'

defineProps<{
  items: StoryBlokArticle[]
  categories: Array<StoryBlokBlogCategory>
  showSection?: boolean
}>()

const appConfig = useAppConfig()
const blog = appConfig.blog
</script>

<template>
  <div class="grid md:grid-rows-2 md:grid-cols-2 lg:grid-flow-col gap-5">
    <div
      v-for="(item, i) in items" :key="i"
      :class="{ 'md:row-span-2 md:col-span-2': i === 0 }"
    >
      <StoryblokLink
        :to="`${blog.url}/${item.slug}`" class="relative md:overflow-hidden block rounded-xl transition lg:shadow-passive hover:shadow-hover"
        :class="{ 'flex grid-cols-2 grid-rows-2 grid-flow-col gap-2.5 md:block md:gap-0': i > 0 }"
      >
        <StoryblokImage
          v-if="item.content.image"
          :src="item.content.image"
          :width="i === 0 ? '780' : '360'"
          :mwidth="i === 0 ? '760' : '100'"
          :height="i === 0 ? '380' : '180'"
          :mheight="i === 0 ? '460' : '70'"
          class="rounded-xl w-full flex-shrink-0 min-w-100px max-h-380px"
        />
        <div>
          <div
            class="z-2"
            :class="{
              'text-white max-w-780px left-5 bottom-5 absolute pr-10 z-2': i === 0,
              'md:max-w-380px md:text-white md:left-5 md:bottom-5 md:absolute md:pr-10': i > 0,
            }"
          >
            <h2 v-if="i === 0" class="pb-1.5 text-shadow text-20px md:text-36px lg:pb-2.5 lg:leading-50px">
              {{ item.content.title }}
            </h2>
            <h4 v-else class="pb-1 leading-tight">
              {{ item.content.title }}
            </h4>
            <div class="flex flex-wrap text-sm opacity leading-16px opacity-75">
              <div v-if="item.content.publishDate" class="pr-2.5 leading-16px">
                {{ useFormatDate(item.content.publishDate, 'd. M. yyyy') }}
              </div>
              <div>|</div>
              <div class="px-2.5">
                {{ blog.articleLength }}: {{ item.content.readTime }} min.
              </div>
            </div>
          </div>
          <div
            v-if="!showSection"
            class="z-2 "
            :class="{ 'block my-0 absolute left-2.5 top-2.5 md:left-5 md:top-5 ': i === 0, 'md:my-0 md:absolute md:left-2.5 md:top-2.5 md:left-5 md:top-5 w-full mt-2': i > 0 }"
          >
            <object class="flex flex-wrap gap-2 lg:gap-2.55">
              <template v-if="item.content.sections.length">
                <StoryblokLink v-for="(cat, ci) in item.content.sections" :key="ci" :to="`${blog.url}${useBlogCategory(cat, categories)?.slug}`" class="bg-white rounded-md border border-gray text-sm px-2.5 leading-24px">
                  {{ useBlogCategory(cat, categories)?.name }}
                </StoryblokLink>
              </template>
              <template v-else>
                <StoryblokLink v-for="(cat, ci) in item.content.categories" :key="ci" :to="`${blog.url}${useBlogCategoryFallback(cat, categories)?.slug}`" class="bg-white rounded-md border border-gray text-sm px-2.5 leading-24px">
                  {{ useBlogCategoryFallback(cat, categories)?.name }}
                </StoryblokLink>
              </template>
            </object>
          </div>
        </div>

        <div
          :class="{ 'hidden md:block': i > 0 }"
          class="absolute left-0 top-0 w-full h-full max-h-380px rounded-xl bg-gradient-to-b from-transparent to-black opacity-40 z-1"
        />
      </StoryblokLink>
      <hr v-if="i === 1" class="md:hidden mt-5 border-primary opacity-30 border-t-1">
    </div>
  </div>
</template>
